import {FaIcon, PageHeader} from 'client/js/util/layout_utils';
import {Link} from 'react-router-dom';
import {withLoading} from 'client/js/util/rest_utils';
import ConfirmedDelete from 'client/js/util/confirmed_delete';
import HandleDetails from './handle';
import {useQuery, useMutation} from '@tanstack/react-query';
import LoadingTableSpinner from 'client/js/util/loading_table_spinner';
import {errorToComponent, errorToToast} from 'client/js/util/rest_utils';
import {toast} from 'react-toastify';

const fetchData = async (id) => {
  const response = await $.ajax({ url: `/usercp/handles/${id}`, dataType: 'json' });

  return response;
}

const IcannValidationBanner = ({ handle, refetch }) => {
  if (!handle.rrpproxy_handle) {
    return null;
  }

  const { isLoading, mutate } = useMutation((id) => {
    return $.ajax({
      url: `/usercp/handles/${id}/request_verification_token`,
      type: 'POST',
      dataType: 'json'
    });
  }, {
    onSuccess: (data) => {
      toast.success(data.message || 'Verification-Token wurde erfolgreich gesendet!');
      setTimeout(() => refetch(), 2000); // Refetch after 2 seconds to update status
    },
    onError: (error) => {
      errorToToast(error, "beim Senden des Verification-Tokens");
    }
  });

  const handleClick = (e) => {
    e.preventDefault();
    mutate(handle.id);
  }

  if (handle.icann_verified) {
    return (
      <div className="alert alert-success">
        <strong>ICANN-Verifizierung erfolgreich</strong>
        {' '}
        Der Domaininhaberkontakt ist verifiziert. Falls Du Domains mit diesem Kontakt besitzt, die noch auf "ICANN Suspended" oder "ICANN Unverified" stehen, kann es bis zu einer Stunde dauern, bis die Domain als validiert markiert wird.
      </div>
    );
  }

  return (
    <div className="alert alert-warning">
      <div className="d-flex justify-content-between align-items-center">
        <div>
          <strong>ICANN-Verifizierung erforderlich</strong>
          {' '}
          Dieser Domaininhaberkontakt ist nicht verifiziert. Für Domains mit diesem Kontakt kann eine Verifizierung erforderlich sein. Du kannst das Verification-Token erneut an Deine E-Mail-Adresse senden lassen.
        </div>
        <button
          type="button"
          onClick={handleClick}
          className="btn btn-warning text-nowrap"
          disabled={isLoading}
        >
          {isLoading && <div className="css-spinloader inline mr-1"></div>}
          <FaIcon name="envelope" /> Token senden
        </button>
      </div>
    </div>
  );
}

const Page = (props) => {
  const { data, isLoading, isError, error, refetch } = useQuery(['handle', props.match.params.id], () => fetchData(props.match.params.id));

  if(isLoading) {
    return <>
      <PageHeader text="Adresse anzeigen" back_url="/handles" />

      <LoadingTableSpinner />
    </>
  }

  if(isError) {
    return errorToComponent(error);
  }

  const handle = data.handle;

  const buttons = <>
    <Link to={`/handles/${handle.id}/edit`} className="btn btn-light"><FaIcon name="pencil" /> bearbeiten</Link>

    <ConfirmedDelete id={handle.id} disabled={!handle.deletable} resource="handles" button_text={<><FaIcon name="trash" /> löschen</>}
      button_class="btn btn-danger" text="Dies wird die Adresse löschen. Sollten gesetzliche Aufbewahrungspflichten bestehen wird die Adresse als gelöscht markiert und nach Ablauf der Aufbewahrungspflichten gelöscht."
      success_cb={() => { props.history.push('/handles') }} />
  </>;

  return <>
    <PageHeader text="Adresse anzeigen" back_url="/handles" buttons={buttons}>
      Adresse anzeigen
    </PageHeader>

    <IcannValidationBanner handle={handle} refetch={refetch} />

    <div className="row">
      <div className="col-md-6">
          <HandleDetails handle={handle} />
      </div>
    </div>
  </>;
}

export default Page;
